import {useContext} from 'react';
import {StripeAssistantWidgetHeader} from '@stripe-internal/conversations-ui';
import {ConfigContext} from '../Providers/ConfigProvider';

export function HeaderNext() {
  const {entrypoint} = useContext(ConfigContext);

  return (
    <StripeAssistantWidgetHeader
      supportCenterHref={'https://dashboard.stripe.com/support'}
      entryPoint={entrypoint}
    />
  );
}
